import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { HttpTimeoutError } from '@cian/peperrors/shared';
import {
  fetchSeourlsGetSeoUrlsFromQueryStrings,
  ISeourlsGetSeoUrlsFromQueryStringsRequest,
  ISeourlsGetSeoUrlsFromQueryStringsResponse200,
  ISeourlsGetSeoUrlsFromQueryStringsResponse400,
} from '../repositories/monolith-python/unversioned/seourls-get-seo-urls-from-query-strings';
import { ApiCache, GET_SEO_URLS_API_CACHE_KEY } from './apiCache';

export interface ISeoUrls {
  [key: string]: string | null;
}

export async function getSeoUrls(
  httpApi: IHttpApi,
  logger: ILogger,
  parameters: ISeourlsGetSeoUrlsFromQueryStringsRequest,
  subdomain: string = 'www',
  timeout: number = 10000,
  seoApiCacheEnabled?: boolean,
) {
  try {
    const cacheKey = `${GET_SEO_URLS_API_CACHE_KEY}_${parameters.queryStrings[0]}`;
    if (seoApiCacheEnabled) {
      const cacheData = ApiCache.getData<ISeoUrls>(cacheKey);
      if (typeof cacheData !== 'undefined') {
        return cacheData;
      }
    }

    const { response, statusCode } = await fetchSeourlsGetSeoUrlsFromQueryStrings<
      ISeourlsGetSeoUrlsFromQueryStringsResponse200,
      ISeourlsGetSeoUrlsFromQueryStringsResponse400
    >({
      httpApi,
      parameters,
      config: {
        subdomain,
        ecnhancersConfig: {
          timeout,
        },
      },
    });

    if (statusCode !== 200 || 'errors' in response) {
      throw response;
    }

    if (seoApiCacheEnabled) {
      ApiCache.setData(cacheKey, response.data.seoUrls || null);
    }

    return response.data.seoUrls;
  } catch (error) {
    let message;
    if (error instanceof HttpTimeoutError) {
      message = 'TimeoutError in getSeoUrls';
    } else {
      message = 'Error in getSeoUrls';
    }
    logger.error(error, { message });

    return null;
  }
}
